import { useEffect, useState } from "react";
import { toast } from "sonner";
import { listConversations, clearConversations } from "@/lib/api";
import { errorText } from "@/lib/family";
import { HistoryItem } from "@/components/HistoryItem";

export const FamilyHistory = ({ pin, profiles }) => {
  const [filter, setFilter] = useState("");
  const [items, setItems] = useState([]);
  const load = () => listConversations(filter).then(setItems);
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const clear = async () => {
    const who = filter ? (profiles.find((p) => p.id === filter)?.name || "Guest") : "everyone";
    if (!window.confirm(`Clear history for ${who}?`)) return;
    try { await clearConversations(pin, filter); toast.success("History cleared"); load(); }
    catch (err) { toast.error(errorText(err)); }
  };

  const tabs = [["", "Everyone"], ...profiles.map((p) => [p.id, p.name]), ["guest", "Guest"]];
  return (
    <section className="pp-card" data-testid="family-history">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="pp-h2">Kind requests</h2>
        <button className="pp-ghost" onClick={clear} disabled={!items.length} data-testid="family-clear-history-button">Clear history</button>
      </div>
      <div className="pp-presets" role="tablist">
        {tabs.map(([id, label]) => (
          <button key={id || "all"} className={`pp-pill ${filter === id ? "on" : ""}`} onClick={() => setFilter(id)}
            data-testid={`history-filter-${id || "all"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="mt-5 grid gap-3 md:grid-cols-2">
        {items.length === 0 && <p className="pp-sub" data-testid="family-history-empty">Nothing here yet.</p>}
        {items.map((c) => <HistoryItem key={c.id} c={c} showName />)}
      </div>
    </section>
  );
};
